export default "__VITE_ASSET__BRZFU4tp__"